import { Component, OnInit } from '@angular/core';
import { SessionService } from './service/session.service';
import { AppService } from './service/app.service';
import { IStringAnyMap } from './app.types';
import { NavigationEnd, Router } from '@angular/router';
import { MatomoService } from './service/matomo.service';

declare let _paq: any; // Declare Matomo for TypeScript

@Component({
  selector: 'flow-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  
  

  constructor(
    public sessionSrv : SessionService,
    private router: Router,
    private Matomo : MatomoService,
  ) {}

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.Matomo.trackPageView(event.urlAfterRedirects);
      }
    });
  }

}
